import React from "react";
import { Link } from "react-router-dom";

// Default services data as fallback
const defaultServices = [
  {
    title: "Federal & State Notice Resolution",
    desc: "Expert resolution of IRS and state tax notices. Swift response, negotiations, and compliance so you can breathe easy.",
    path: "/taxfiling/fdrl-state-notice-resolution",
    icon: <i className="bi bi-envelope-exclamation fs-2 text-warning"></i>,
    bg: "#fff8e7"
  },
  {
    title: "Expert Consulting",
    desc: "Get IRS audit defense, business process consulting, and year-round tax advice from Nexen's seasoned professionals.",
    path: "/taxfiling/expert-consulting",
    icon: <i className="bi bi-patch-check-fill fs-2 text-primary"></i>,
    bg: "#f2f3ff"
  },
  {
    title: "ITIN Assistance",
    desc: "From new ITIN applications to fast renewals or consultation, our team will make the IRS process simple.",
    path: "/taxfiling/itin-assistance",
    icon: <i className="bi bi-person-badge fs-2 text-pink" style={{color: "#D53F8C"}}></i>,
    bg: "#fff0f8"
  },
  {
    title: "Staffing",
    desc: "Flexible IT and business staffing solutions—from contract to permanent—to expand your team and drive results.",
    path: "/services/staffing",
    icon: <i className="bi bi-people-fill fs-2" style={{ color: "#6B46C1" }}></i>,
    bg: "#e5e8fb"
  },
  {
    title: "FBAR & FATCA Filing",
    desc: "Comprehensive filing assistance for foreign account and asset compliance, helping you avoid costly penalties.",
    path: "/taxfiling/fbar-facta-filing",
    icon: <i className="bi bi-globe2 fs-2" style={{ color: "#D53F8C" }}></i>,
    bg: "#f5e2f0"
  },
  {
    title: "Tax Preparation",
    desc: "Personal and business tax return filing for U.S. and expat clients. Fast, accurate, and stress-free.",
    path: "/taxfiling/tax-preparation",
    icon: <i className="bi bi-calculator fs-2 text-success"></i>,
    bg: "#e5f5eb"
  },
];

export default function Services({ content }) {
  // Use API content if available, otherwise fall back to default
  const services = content?.tax_services?.concat(content?.business_services || []) || defaultServices;
  return (
    <section className="py-6 bg-white" id="services">
      <div className="container" style={{ paddingTop: "30px" }}>
        <h2
          className="fw-bold mb-5 text-center"
          style={{
            fontFamily: "'Poppins',sans-serif",
            background: "linear-gradient(90deg, #6B46C1, #D53F8C 60%)",
            color: "transparent",
            backgroundClip: "text",
            WebkitBackgroundClip: "text"
          }}
        >
          Our Services
        </h2>
        <div className="row g-4 justify-content-center">
          {services.map((srv, i) => (
            <div
              className="col-12 col-sm-6 col-md-4"
              key={srv.title}
              data-aos="fade-up"
              data-aos-delay={i * 120}
            >
              <Link
                to={srv.path}
                className="text-decoration-none"
                style={{ color: "#24254b" }}
              >
                <div
                  className="card border-0 shadow-sm rounded-4 h-100 p-4 service-card-home"
                  style={{background: srv.bg, minHeight: 225}}
                >
                  <div className="mb-3">{srv.icon}</div>
                  <div className="fw-bold fs-5 mb-2" style={{ fontFamily: "'Poppins',sans-serif" }}>{srv.title}</div>
                  <p className="text-secondary mb-0" style={{ minHeight: 65 }}>{srv.desc}</p>
                  <span className="fw-semibold mt-3 d-inline-block text-primary" style={{ fontSize:16 }}>
                    Learn More <i className="bi bi-arrow-right"></i>
                  </span>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>

      {/* Card hover effect */}
      <style>{`
        .service-card-home {
          transition: box-shadow 0.18s, transform 0.18s;
        }
        .service-card-home:hover {
          box-shadow: 0 10px 32px #6b46c11a;
          transform: translateY(-7px) scale(1.035);
          z-index: 5;
        }
      `}</style>
      {/* Bootstrap Icons CDN if not already loaded */}
      <link
        rel="stylesheet"
        href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.10.3/font/bootstrap-icons.css"
      />
    </section>
  );
}

